import type { FilterDrawerState, FilterDrawerCollectionRestrictedValues } from '../../types';
import { FilterParamIdDescriptor, FilterParamValueType } from '../types';

export const getParamsFromFilter = ({
	filter,
	touchedFilterItems
}: {
	filter: FilterDrawerState;
	touchedFilterItems: Record<string, true>;
}) => {
	const params: Record<string, FilterDrawerCollectionRestrictedValues> = Object.values(
		filter
	).reduce((accumulator, { filterCollectionId, value, inclusive }) => {
		if (!touchedFilterItems[filterCollectionId]) return accumulator;

		const idType = `${filterCollectionId}_${FilterParamIdDescriptor.Type}`;
		const idInclusive = `${filterCollectionId}_${FilterParamIdDescriptor.Inclusive}`;

		const partialParams: Record<string, FilterDrawerCollectionRestrictedValues> = {};

		/* handle array value */
		if (Array.isArray(value)) {
			if (value[0]) {
				partialParams[filterCollectionId] = value.map((item) =>
					encodeURIComponent(item)
				) as string[];

				/* handle array with string values */
				if (typeof value[0] === 'string') {
					partialParams[idType] = FilterParamValueType.StringArray;
				}

				/* handle array with number values */
				if (typeof value[0] === 'number') {
					partialParams[idType] = FilterParamValueType.NumberArray;
				}
			}
		}

		/* handle string value */
		if (typeof value === 'string') {
			partialParams[filterCollectionId] = encodeURIComponent(String(value));
			partialParams[idType] = FilterParamValueType.String;
		}

		/* handle number value */
		if (typeof value === 'number') {
			partialParams[filterCollectionId] = encodeURIComponent(String(value));
			partialParams[idType] = FilterParamValueType.Number;
		}

		/* handle booleans */
		if (typeof value === 'boolean' && value) {
			partialParams[filterCollectionId] = encodeURIComponent(String(value));
			partialParams[idType] = FilterParamValueType.Boolean;
		}

		/* handle inclusive */
		if (typeof inclusive === 'boolean') {
			partialParams[idInclusive] = String(inclusive);
		}

		return {
			...accumulator,
			...partialParams
		};
	}, {});

	return params;
};
